var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50051,
    cy: 3.04348,
    r: 2.54348,
    stroke: "#474F60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.804688 13.3913C0.804688 13.3913 0.804688 13.3913 0.804688 13.3913V14H2.02208V13.3913C2.02208 13.3913 2.02208 13.3913 2.02208 13.3913C2.0221 11.0381 3.92975 9.13048 6.28295 9.13048H8.71773C10.8643 9.13048 12.6401 10.7178 12.9355 12.7827H3.23947V14H14.196V13.3913C14.196 10.3658 11.7433 7.91309 8.71773 7.91309H6.28295C3.2574 7.91309 0.80471 10.3658 0.804688 13.3913Z",
    fill: "#474F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMember);
export default __webpack_public_path__ + "static/media/icon_member.dd453443fe416c8569b040003c54851a.svg";
export { ForwardRef as ReactComponent };